import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css, cx } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import RawPlatMap from '@bd/bdui-platmap';
import withData from '@bd/bdcore-data';
import AccordionToggle from '../../components/AccordionToggle';
import { colors, typography } from '../../styles';

const PlatMap = withData(
  {
    community: true,
    lots: true,
    homes: true,
  },
  {
    community: true,
  },
)(RawPlatMap);

const styles = css`
  color: #FFFFFF;
  .SectionAbout_descriptionHead, .SectionAbout_schoolsHead{
    text-align: center;
  }
  .SectionAbout_descriptionHead {
    display: none;
    @media (min-width: 768px) {
      display: block;
      margin-bottom: 0.4em;
    }
  }
  .SectionAbout_descWrapper {
    @media (min-width: 992px) {
      &::after {
        content: '';
        display: table;
        clear: both;
      }
    }
  }
  .SectionAbout_description {
    font-size: 15px;
    font-weight: 300;
    letter-spacing: 0.022353em;
    line-height: 1.941176;
    margin: 0;
    text-align: center;
    @media (min-width: 768px) {
      font-size: 16px;
    }
    @media (min-width: 992px) {
      font-size: 17px;
    }
  }

  .SectionAbout_schoolsSection {
    color: ${colors.color5};
    margin-top: 28px;
    @media (min-width: 768px) {
      margin-top: 52px;
    }
    @media (min-width: 992px) {
      margin-top: 57px;
    }
  }
  .SectionAbout_schoolsHead {
    margin-bottom: 0.4em;
  }
  .SectionAbout_schoolsListPrimary {

  }
  .SectionAbout_schoolsListItemPrimary {
    &:not(:first-child) {
      margin-top: 30px;
    }
    @media (min-width: 768px) {
      &:not(:first-child) {
        margin-top: 32px;
      }
    }
    @media (min-width: 992px) {
      &:not(:first-child) {
        margin-top: 34px;
      }
    }
  }
  .SectionAbout_schoolsListSecondary {
    @media (min-width: 768px) {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px -10px;
    }
    @media (min-width: 992px) {
      margin: 0 -14.5px -14.5px;
    }
  }
  .SectionAbout_schoolsListItemSecondary {
    font-size: 15px;
    font-weight: 300;
    letter-spacing: 0.025em;
    line-height: 1.375;
    @media (max-width: 767.98px) {
      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
    @media (min-width: 768px) {
      font-weight: bold;
      line-height: 1.1;
      height: 52px;
      width: calc(33.333333% - 20px);
      margin: 0 10px 10px;
    }
    @media (min-width: 992px) {
      font-size: 16px;
      height: 55px;
      width: calc(33.333333% - 29px);
      margin: 0 14.5px 14.5px;
    }
  }
  .SectionAbout_schoolDistrict {
    display: block;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.022105em;
    line-height: 1.736842;
    margin-bottom: 0.421053em;
    @media (min-width: 768px) {
      font-size: 18px;
    }
    @media (min-width: 992px) {
      font-size: 19px;
    }
  }
  .SectionAbout_schoolsListLink {
    @media (min-width: 768px) {
      padding: 0 16px;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
    @media (min-width: 992px) {
      padding: 0 20px;
    }
  }


  .LightBox_button {
      cursor: pointer;
    }
    .AccordionToggle_contentInterior   {
      padding: 20px;
    }
    position: relative;
    @media(min-width: 992px) {
      padding: 70px 0;
    }
    h3, h4 {
      text-align: center;
    }
    .leaflet-container {
      height: 600px !important;
    }
    .leaflet-popup-pane {
    }
    .PlatMap_wrapper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index:1;
      @media(min-width: 768px) {
        padding: 0 60px;
      }
      @media(max-width: 768px) {
        padding-top: 0 90px;
      }
    }
    .CommunityMap_wrapper {
      height: 600px;
      position: relative;
    }
    .SitePlanModal_platMap .leaflet-container {
      height: 600px;
    }

    .leaflet-popup-content {
      @media(max-width: 991px) {
        width: 200px !important;
      }
    }

    .leaflet-popup-content-wrapper {
      border-radius: 0;
      .HomePopup_wrapper {
        display: flex;
        a, div {
          display: flex;
          flex-direction: column;
          font-family: ${typography.SansSerif};
          color: #242424;
          .HomePopup_title {
            color: ${colors.h1};
            text-align: left;
            font-weight: 700;
            font-size: 19px;
            letter-spacing: 0;
            margin: 0;
          }
          .HomePopup_address {
            font-size: 13px;
            letter-spacing: 0;
            text-transform: uppercase;
          }
          .HomePopup_status {
            text-transform: uppercase;
            font-size: 12;
            font-weight: 800;
            color: ${colors.h1};
          }
          .Btn_learnMore {
            background-color: ${colors.h1};
            height: 30px;
            margin-top: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
            text-transform: uppercase;
            font-weight: 800;
            font-size: 11px;
          }
        }
        a{
          &:hover {
            opacity: 0.7;
          }

        }
      }
    }

  .legend {
  margin-bottom: 15px;
    span {
      padding: 0 60px;
    }
    .sold {
      background: ${colors.sold};
      border: red 3px solid;
      border-radius: 4px;
    }
  }
  .key{
  display: inline-flex;
  align-items: center;
  margin-right: 30px;
  }
  .circle{
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  }
  .color_legend {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    list-style: none;
    /* border-bottom: 1px solid #E9E9E9; */
    li {
      float: left; margin-right: 10px;
      margin-bottom: 10px;
    }
    span {
      width: 20px;
      height: 20px;
      float: left;
      margin: 2px 6px 2px 2px;
    }
    .sold {
      opacity: .7;
      background-color: ${colors.sold};
      border: 2px solid ${colors.color1};
    }
    .available {
      opacity: .7;
      background-color: ${colors.available};
      border: 2px solid ${colors.color1};
    }
    .other {
      opacity: .7;
      background-color: ${colors.other};
      border: 2px solid ${colors.color1};
    }
    .pending{
      opacity: .7;
      background-color: ${colors.pending};
      border: 2px solid ${colors.color1};}
    }
`;


function SectionPlatMap({ className, community }) {
  return (
    <div className={cx(styles, className)}>
      <AccordionToggle
        openOnId="platMap"
        button="Available Homesites"
        id="platMap"
      >
        {!community.zplatpublished &&
          <div className="SectionAbout_descriptionSection">
            <h2 className={[
              'CommunityDetail_sectionHead',
              'GoldText',
              'SectionAbout_descriptionHead',
              'SectionAbout_descriptionHead-noResults',
            ].join(' ')}
            >
              Available Homesites
            </h2>
            <p className="SectionAbout_description SectionAbout_description-noResults">
              {'No Interactive Home Site available for this property at this time.'}
            </p>
          </div>
        }
        {community.zplatpublished &&
          <div className="SectionAbout_descriptionSection">
            <h2 className="CommunityDetail_sectionHead SectionAbout_descriptionHead GoldText">Available Homesites</h2>
            <div className="SectionAbout_descWrapper">
              <ul className="color_legend">
                <li><span className="available" /> Available</li>
                <li><span className="pending" /> Sale Pending</li>
                <li><span className="sold" /> Sold</li>
                <li><span className="other" /> Other</li>
              </ul>
              <div className="CommunityMap_wrapper">
                <svg>
                  <defs>
                    <linearGradient id="modelGradient">
                      <stop offset="0%" stopColor="orange" />
                      <stop offset="16.7%" stopColor="yellow" />
                      <stop offset="33.3%" stopColor="green" />
                      <stop offset="50%" stopColor="cyan" />
                      <stop offset="66.7%" stopColor="blue" />
                      <stop offset="75%" stopColor="violet" />
                    </linearGradient>
                  </defs>
                </svg>
                <PlatMap
                  shapeStatusStyles={{
                    home: {
                      active: {
                        opacity: 0.7,
                        fillOpacity: 0.7,
                        color: colors.available,
                      },
                      sold: {
                        opacity: 0.7,
                        fillOpacity: 0.7,
                        color: colors.sold,
                      },
                      pending: {
                        opacity: 0.7,
                        fillOpacity: 0.7,
                        color: colors.pending,
                      },
                    },
                    lot: {
                      active: {
                        opacity: 0.7,
                        fillOpacity: 0.7,
                        color: colors.available,
                      },
                      sold: {
                        opacity: 0.7,
                        fillOpacity: 0.7,
                        color: colors.sold,
                      },
                      pending: {
                        opacity: 0.7,
                        fillOpacity: 0.7,
                        color: colors.pending,
                      },
                    },
                    default: {
                      opacity: 0.7,
                      color: colors.other,
                      fillOpacity: 0.43,
                    },
                    sold: {
                      opacity: 0.7,
                      fillOpacity: 0.7,
                      color: colors.sold,
                    },
                    active: {
                      opacity: 0.7,
                      fillOpacity: 0.7,
                      color: colors.available,
                    },
                  }}
                  shapes
                  community={community}
                  popup={({ marker }) => (
                    <div className="home-popup HomeCardsList Vertical">
                      {
                        marker.type === 'home' &&
                        <div className="HomePopup_wrapper">
                          <Link name="home-detail" home={marker}>
                            <h4 className="HomePopup_title">{get(marker, 'address.streetAddress')}</h4>
                            <h5 className="HomePopup_address">{get(marker, 'address.addressLocality')}, {get(marker, 'address.addressRegion')} {get(marker, 'address.postalCode')}</h5>
                            {
                              get(marker, 'price') &&
                              <span>Price: {numeral(get(marker, 'price')).format('$0,0')}</span>
                            }
                            {
                              get(marker, 'status') === 'Active' &&
                              <span className="HomePopup_status">Available Now!</span>
                            }
                            <span className="Btn_learnMore">Learn More</span>
                          </Link>
                        </div>
                      }
                      {
                        marker.type === 'lot' &&
                        <div className="HomePopup_wrapper">
                          <div>
                            <h4 className="HomePopup_title">{get(marker, 'address.streetAddress')}</h4>
                            <h5 className="HomePopup_address">{get(marker, 'address.addressLocality')}, {get(marker, 'address.addressRegion')} {get(marker, 'address.postalCode')}</h5>
                            {
                              get(marker, 'price') &&
                              <span>Price: {numeral(get(marker, 'price')).format('$0,0')}</span>
                            }
                            {
                              get(marker, 'lotSize') &&
                              <span>SQ FT: {get(marker, 'lotSize')}</span>
                            }
                            {
                              get(marker, 'status') === 'Active' &&
                              <span className="HomePopup_status">Available Now!</span>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  )}
                  tooltip={marker => (
                    <div>
                      {
                        !marker.isLot &&
                        <span>
                          Available Home
                          <br />
                          {marker.address.streetAddress}
                        </span>
                      }
                      {
                        marker.isLot &&
                        <span>
                          Available Lot
                          <br />
                          {marker.address.streetAddress}
                        </span>
                      }
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
        }
      </AccordionToggle>
    </div>
  );
}

SectionPlatMap.propTypes = {
  className: PropTypes.string,
  community: PropTypes.object.isRequired,
};

SectionPlatMap.defaultProps = {
  className: undefined,
};

export default SectionPlatMap;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/SectionPlatMap.js